import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Zap } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "technician", phone: "" });
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Konto erstellt!");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registrierung fehlgeschlagen");
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background bg-grain p-6">
      <Card className="w-full max-w-md p-8 rounded-3xl border-border/60 glass">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-primary/15 text-primary flex items-center justify-center"><Zap className="w-5 h-5" /></div>
          <div className="font-heading text-xl font-bold">Navero</div>
        </div>
        <h2 className="font-heading text-2xl font-bold mb-5">Konto erstellen</h2>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div className="space-y-2"><Label>Name</Label>
            <Input value={form.name} onChange={e=>setForm({...form, name:e.target.value})} required data-testid="reg-name" className="rounded-full h-11 px-5" /></div>
          <div className="space-y-2"><Label>E-Mail</Label>
            <Input type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} required data-testid="reg-email" className="rounded-full h-11 px-5" /></div>
          <div className="space-y-2"><Label>Passwort</Label>
            <Input type="password" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} required data-testid="reg-password" className="rounded-full h-11 px-5" /></div>
          <div className="space-y-2"><Label>Telefon (optional)</Label>
            <Input value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})} data-testid="reg-phone" className="rounded-full h-11 px-5" /></div>
          <div className="space-y-2"><Label>Rolle</Label>
            <Select value={form.role} onValueChange={v => setForm({...form, role:v})}>
              <SelectTrigger className="rounded-full h-11 px-5" data-testid="reg-role"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="technician">Mitarbeiter / Techniker</SelectItem>
                <SelectItem value="customer">Kunde</SelectItem>
              </SelectContent>
            </Select>
            <p className="text-[11px] text-muted-foreground mt-1">Agentur-Konten werden ausschließlich vom Inhaber vergeben.</p>
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full h-11 font-semibold" data-testid="reg-submit">
            {loading ? "Erstellen..." : "Konto erstellen"}
          </Button>
        </form>
        <div className="mt-5 text-center text-sm text-muted-foreground">
          Bereits registriert? <Link to="/login" className="text-primary font-semibold" data-testid="link-login">Anmelden</Link>
        </div>
      </Card>
    </div>
  );
}
